//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

import dayjs from 'dayjs'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { CACHE_SETTINGS } from '~/utils/cache'
import { getLocations } from '~/utils/server'
import TheMostPopular from '~/components/section/selection/the-most-popular'
import numberWithCommas from '~/filters/numberWithCommas'
import SearchComponent from '~/components/search/page/search-component.vue'
import SearchOtherBrands from '~/components/search/page/search-other-brands.vue'
import PageTop from '~/components/section/page-top.vue'
import capitalizeFirstLetterFilter from '~/filters/capitalizeFirstLetter'
import toLowerCaseFilter from '~/filters/toLowerCase'
import OtherLocations from '~/components/seo/other-locations.vue'

export default {
  name: 'Brand',
  filters: {
    numberWithCommas,
    capitalizeFirstLetterFilter,
    toLowerCaseFilter
  },
  components: {
    OtherLocations,
    PageTop,
    SearchOtherBrands,
    SearchComponent,
    TheMostPopular,
    OffersInMailbox
  },
  mixins: [pageMeta],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'brand',
          path: ctx.route.path,
          idx: ctx.route.params.slug
        }
      })
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = ietfLocale || 'en-gb'

      const resp = await ctx.$axios.get(`/api/brand/${ctx.route.params.slug}?lang=${lang}`).catch((e) => {
        return null
      })
      if (!resp?.data) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'destinations' }).href)
      }
      ctx.store.commit('page/SET_BRAND', resp.data)

      const otherBrands = await ctx.$axios.get(`/api/brand-pages?lang=${lang}`).catch((e) => {
      })
      ctx.store.commit('page/SET_BRANDS', otherBrands.data)

      const mostPopLocations = await ctx.$cacheFetch({
        key: `pIndex-getLocations?locale=${lang}`, expire: CACHE_SETTINGS.baseTime
      }, async () => {
        return await getLocations(ctx, {
          lang,
          ietf,
          locationType: [
            { id: 'popular' }
          ],
          locationLimit: {
            default: 10,
            popular: 8
          }
        })
      })
      await ctx.store.dispatch('auth/getFavorites')

      return {
        mostPopLocations: mostPopLocations.popular
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      page: {
        sticky: false
      }
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      pageSeoData: state => state.pageData,
      destinationData: state => state.search.destination,
      loading: state => state.search.loading,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      results: state => state.search.results,
      amountResultsFound: state => state.search.amountResultsFound,
      locations: state => state.search.locations,
      hasBeenFiltered: state => state.search.hasBeenFiltered,
      pagination: state => state.search.pagination,
      staticReviews: 'staticReviews'
    }),
    ...mapGetters({
      bar: 'search/bar',
      locale: 'lang/locale',
      brand: 'page/brand',
      brands: 'page/brands',
      searchTerms: 'search/searchTerms'
    }),
    getStartDate () {
      return dayjs(this.$store.state.search.date).toDate()
    },
    getEndDate () {
      return dayjs(this.$store.state.search.date).add(this.$store.state.search.duration, 'd').toDate()
    },
    getBrand () {
      return this.brand
    },
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'popular-destination': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        },
        'guests-say': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 2,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            arrows: false,
            slidesToShow: 'auto',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    },
    getBrandName () {
      return this.$options.filters.capitalizeFirstLetterFilter(this.brand?.name || '')
    },
    getBrandText () {
      return this.brand?.values[0]?.description
    },
    getAboutText () {
      return this.brand?.values[0]?.about
    },
    getTopImage () {
      return this.brand?.top_image
    },
    getShowAllButton () {
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    }
  },
  mounted () {
    this.createdMethod()
    this.$scrollTo({ y: 0 })
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  },
  beforeDestroy () {
    this.$store.commit('search/RESET_FILTERS_SHOW_LIMITS')
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', 'croatia')
      this.$Search.setAttributeValue('limit_date', false)
      this.$Search.setAttributeValue('brand', this.getBrandName)
      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    }
  },
  jsonld () {
    const reviewListItems = this.staticReviews.map((review) => {
      return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: 'Tubber',
        review: {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
            bestRating: 5,
            worstRating: 1
          },
          name: this.$t(review.title),
          author: {
            '@type': 'Person',
            name: this.$t(review.user_name)
          },
          reviewBody: this.$t(review.review_text)
        }
      }
    })
    return {
      name: 'Tubber',
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: reviewListItems
    }
  }
}
